// Attribution for the license-isolated dictionary pillar.
//
// The dictionary is built from two openly-licensed datasets, and BOTH require
// visible attribution. They are deliberately kept apart from Azzurro's own
// grammar content (its own PB collection, its own seed script, this footer):
//
//   • Headwords, glosses, IPA → Wiktextract / kaikki.org, derived from
//     English Wiktionary. Licence: CC BY-SA 4.0 (ShareAlike). Because of
//     ShareAlike we surface this ONLY on dictionary surfaces, never mixed into
//     the hand-authored articles/verbs/vocabulary.
//   • Example sentences → Tatoeba. Licence: CC BY 2.0 FR.
//
// Render this footer on any view that shows dictionary_entries data. Keep the
// links intact — attribution is a licence condition, not decoration.

export const DICTIONARY_SOURCES = [
  {
    label: "Wiktionary / Wiktextract (kaikki.org)",
    license: "CC BY-SA 4.0",
    licenseUrl: "https://creativecommons.org/licenses/by-sa/4.0/",
    sourceUrl: "https://kaikki.org/",
  },
  {
    label: "Tatoeba example sentences",
    license: "CC BY 2.0 FR",
    licenseUrl: "https://creativecommons.org/licenses/by/2.0/fr/",
    sourceUrl: "https://tatoeba.org/",
  },
];

// One-line plain-text form (for the seed log, exports, or a compact footer).
export const DICTIONARY_ATTRIBUTION_TEXT =
  "Dictionary data from Wiktionary via Wiktextract (kaikki.org), CC BY-SA 4.0. " +
  "Example sentences from Tatoeba, CC BY 2.0 FR. " +
  "Azzurro adds and corrects entries; this dictionary section is shared under CC BY-SA 4.0.";

// HTML footer for dictionary views. Trusted, code-authored markup — safe to
// inject as innerHTML (no user content).
export function dictionaryAttributionHTML() {
  const parts = DICTIONARY_SOURCES.map(
    (s) =>
      `<a href="${s.sourceUrl}" target="_blank" rel="noopener">${s.label}</a> ` +
      `(<a href="${s.licenseUrl}" target="_blank" rel="noopener">${s.license}</a>)`
  );
  return `
  <p class="dictionary-attribution text-xs text-sage-500 mt-6 leading-relaxed">
    Dictionary entries derived from ${parts[0]} and ${parts[1]}.
    Azzurro’s additions and corrections to this dictionary section are likewise
    shared under CC BY-SA 4.0.
  </p>`;
}
